import React, { useState } from 'react';
import { Button } from '@mui/material';
import CloudDownloadOutlinedIcon from '@mui/icons-material/CloudDownloadOutlined';
import { useTranslation } from '../../app/LanguageContext';
import MakerworldImportDialog from './MakerworldImportDialog';

export default function MakerworldImportButton() {
  const { translate } = useTranslation();
  const [open, setOpen] = useState(false);

  return (
    <>
      <Button
        size="small"
        variant="outlined"
        startIcon={<CloudDownloadOutlinedIcon />}
        onClick={() => setOpen(true)}
      >
        {translate('extensions.makerworld_import.button')}
      </Button>
      <MakerworldImportDialog open={open} onClose={() => setOpen(false)} />
    </>
  );
}
